import { useT } from "../../i18n/index.js";
import { Button } from "../../ui/Button.js";
import { baseApi } from "../api.js";
import { useBase } from "../state.js";
import { Sheet } from "./shared.js";

/** Saved layouts: store the current arrangement or move everything back to a saved one (R13). */
export function LayoutPanel() {
  const t = useT();
  const base = useBase((s) => s.base);
  const run = useBase((s) => s.run);
  const setPanel = useBase((s) => s.setPanel);
  if (!base) return null;
  const slots = Array.from({ length: base.layoutSlots }, (_, i) => i + 1);
  return (
    <Sheet title={t("base.layouts.title")} onClose={() => setPanel({ kind: "none" })} testId="layout-panel">
      <p className="hint" style={{ marginTop: 0 }}>{t("base.layouts.hint")}</p>
      {slots.map((slot) => {
        const saved = base.layouts.find((l) => l.slot === slot);
        return (
          <div key={slot} className="row list-row" data-testid={`layout-${slot}`}>
            <span className="grow">
              <strong>{t("base.layouts.slot", { n: slot })}</strong>
              <div className="hint">{saved ? new Date(saved.savedAt).toLocaleString() : t("base.layouts.empty")}</div>
            </span>
            <Button style={{ minHeight: 36 }} onClick={() => void run(() => baseApi.saveLayout(slot), t("base.toast.layoutSaved"))} data-testid={`layout-save-${slot}`}>
              {t("common.save")}
            </Button>
            <Button variant="primary" style={{ minHeight: 36 }} disabled={!saved} onClick={() => void run(() => baseApi.applyLayout(slot), t("base.toast.layoutApplied"))} data-testid={`layout-apply-${slot}`}>
              {t("base.layouts.apply")}
            </Button>
          </div>
        );
      })}
    </Sheet>
  );
}
